import React from 'react';
import ReactPaginate from 'react-paginate';

import { IPaginator } from './interface';
import { isMobileDevice } from 'utils/ScreenUtils';

import { Container } from './styles';

const Paginator: React.FC<IPaginator> = (props) => {
  const { totalPage, onPageChange, currentPage, minifyed, show } = props;

  const isMobile = isMobileDevice();

  const pageRangeDisplayed = isMobile ? 0 : 3;

  const isMinifyed = minifyed ? ' minifyed' : '';
  const isMinifyedHide = minifyed ? ' hide' : '';
  const isMinifyedNext = minifyed ? undefined : '>>';
  const isMinifyedPrevious = minifyed ? undefined : '<<';

  return (show || show === undefined) && totalPage && totalPage > 1 ? (
    <Container>
      <ReactPaginate
        forcePage={currentPage}
        pageCount={totalPage || 1}
        pageRangeDisplayed={pageRangeDisplayed}
        marginPagesDisplayed={1}
        containerClassName="d-flex w-100 mt-2 align-center justify-center py-1 user-select-none"
        pageClassName={`page-item${isMinifyed}`}
        breakClassName={`page-item${isMinifyed}`}
        nextClassName={`page-item${isMinifyedHide}`}
        previousClassName={`page-item${isMinifyedHide}`}
        activeClassName={`page-item active${isMinifyed}`}
        nextLabel={`${isMinifyedNext}`}
        previousLabel={`${isMinifyedPrevious}`}
        onPageChange={(page) => onPageChange(page.selected)}
      />
    </Container>
  ) : null;
};

export default Paginator;
